import useBaseActions from "./actions/base.actions";
import httpUtils from "../Utils/http.utils";
import userUtils from "../Utils/user.utils";
import { BASE_API_ROUTES } from "../constants/apis.constants";
import { getAPIData } from "../Utils/commonApi";
import { BASE_API_PAGE_ENUMS } from "../constants/apis.constants";
import { BASE_API_PATHS } from "../constants/apis.constants";
import { postData } from "../Utils/commonApi";

const useIntegrationActions = () => {
  const { sendRequest, authTokens } = useBaseActions();

  const getConfigurationMappingList = ({
    page,
    limit,
    sellOrAse,
    search
  }) => {
    const query = httpUtils.generateQueryString({
      accessKey: userUtils.getUserMessage(),
      pageNo: page,
      pageLimit: limit,
      SellOrASE: sellOrAse,
      searchString: search,
    });
    const path = `${BASE_API_ROUTES.getConfigurationMappingList}${query}`;
    return sendRequest(path);
  }

  const rateAIMapping = ({
    objectId,
    rating,
    objectType 
  }) => {
    const query = httpUtils.generateQueryString({
      accessKey: userUtils.getUserMessage(),
      ObjectId: objectId,
      rating: rating ? "1" : "0",
      objectType
    });
    const path = `${BASE_API_ROUTES.rateAIMapping}${query}`;
    return sendRequest(path, 'POST', {});
  }

  const reviewAssetMapping = ({ objectId }) => {
    const query = httpUtils.generateQueryString({
      accessKey: userUtils.getUserMessage(),
      ObjectId: objectId,
    });
    const path = `${BASE_API_ROUTES.reviewAssetsMapping}${query}`;
    return sendRequest(path, 'POST', {});
  }

  const getAllTechsByIntegration = ({ integrationId, customerId }) => {
    return getAPIData(BASE_API_PAGE_ENUMS.GetAllTechsByIntegration, authTokens, {
      accessKey: userUtils.getUserMessage(),
      optionEnum1: integrationId,
      ...(customerId && { optionEnum2: customerId }),
    })
  }

  const getSuggestions = ({ clientId }) => {
    return getAPIData(BASE_API_PAGE_ENUMS.GetSuggestions, authTokens, {
      accessKey: userUtils.getUserMessage(),
      optionEnum1: clientId,
    })
  }

  const getRecurringSpend = ({ clientId, sortVisibiityList = [] }) => {
    const query = httpUtils.generateQueryString({
      accessKey: userUtils.getUserMessage(),
    });
    const payload = httpUtils.toFormData({
      CategoryId: 0,
      SubCategoryId: 0,
      objId_Customer: clientId,
      optionEnum98: clientId,
      MSPClientSortVisibility_List: sortVisibiityList
    })
    const path = `${BASE_API_ROUTES.getRecurringSpend}${query}`;
    return sendRequest(path, 'POST', payload);
  }

  const reviewSuggestions = ({ clientId, reviewClicked = 0 }) => {
    return getAPIData(BASE_API_PAGE_ENUMS.ReviewSuggestions, authTokens, {
      accessKey: userUtils.getUserMessage(),
      optionEnum1: clientId,
      optionEnum2: String(reviewClicked)
    })
  }

  const mapLighthouseProducts = ({ tenentId, clientId, toolName, technologyEnum, technologyName, notInUse }) => {
    return postData(authTokens, BASE_API_PATHS.mapLighthouseProducts, {
      accessKey: userUtils.getUserMessage(),
      objId_Customer: clientId,
      tenentId: tenentId,
      ToolName: toolName,
      TechnologyEnum: technologyEnum,
      TechnologyName: technologyName,
      NotInUse: notInUse,
    })
  }

  const getAIProductMapping = ({ clientId, integrationId }) => {
    return postData(authTokens, BASE_API_PATHS.getAIProductMapping, {
      objId_SystemOwner: clientId,
      IntegrationId: integrationId,
    })
  }

  const createUpdateAIProductMapping = ({ clientId, integrationId, productId, categoryId, subcategoryId, hasDistributedSpend, Allocation }) => {
    return postData(authTokens, BASE_API_PATHS.createUpdateAIProductMapping, {
      objId_SystemOwner: clientId,
      IntegrationId: integrationId,
      ProductId: productId,
      CategoryId: categoryId,
      SubcategoryId: subcategoryId,
      hasDistributedSpend,
      Allocation,
    })
  }

  const startSmartMapping = ({ integrationId }) => {
    return postData(authTokens, BASE_API_PATHS.startSmartMapping, {
      accessKey: userUtils.getUserMessage(),
      IntegrationId: integrationId,
    })
  }

  const undoSmartMapping = ({ integrationId }) => {
    return postData(authTokens, BASE_API_PATHS.undoSmartMapping, {
      accessKey: userUtils.getUserMessage(),
      IntegrationId: integrationId,
    })
  }

  const removeAIProductMapping = ({ exceptionId }) => {
    return postData(authTokens, BASE_API_PATHS.removeAIProductMapping, {
      ExceptionId: exceptionId,
    })
  }

  return {
    getConfigurationMappingList,
    rateAIMapping,
    reviewAssetMapping,
    getAllTechsByIntegration,
    getSuggestions,
    getRecurringSpend,
    reviewSuggestions,
    mapLighthouseProducts,
    getAIProductMapping,
    createUpdateAIProductMapping,
    startSmartMapping,
    undoSmartMapping,
    removeAIProductMapping,
  }
}

export default useIntegrationActions;
